export enum EnumDemandMotif {
  DEVIS = 'Demande de devis',
  REQUALIFIED = 'Demande requalifiée / traitée via un autre canal',
  RECLAMATION_COMMERCIALE = 'Réclamation commerciale',
  AUTRE = 'Autre',
}

export enum EnumCodeMotif {
  DEMANDE_DEVIS = 'DEMANDE_DE_DEVIS',
  DEMANDES_DINFORMATION_COMMERCIALE_OFFRE = "DEMANDES_D'INFORMATION_COMMERCIALE/OFFRE",
  UNFOUND_DOCUMENT = 'DEMANDE_DOCUMENT_MANQUANT',
}
